import { createAction, props } from "@ngrx/store";
import { IOrder } from "../model/order.model";

export const getOrderData = createAction('[Order] Get Order Data', props<{ orderId: string }>());
export const getOrderDataSuccess = createAction('[Order] Get Order Data Success', (order: IOrder) => ({order}));
export const getOrderDataFailure = createAction('[Order] Get Order Data Failure', (error: string) => ({ error }));

export const orderActions = {
    getOrderData,
    getOrderDataSuccess,
    getOrderDataFailure
}
